<div class="mt-5">
  <div *ngIf="!estadoDePagoLoaded">
    <div class="col-4 offset-4">
      <lib-sura-skeleton
        align="center"
        figure="circle"
        [loading]="true"
        width="6rem"
        height="6rem"
      ></lib-sura-skeleton>
      <div class="py-4 mx-auto">
        <lib-sura-skeleton
          align="center"
          figure="rectangle"
          [loading]="true"
          width="60%"
          height="3rem"
        >
        </lib-sura-skeleton>
      </div>
    </div>
    <div class="col-8 offset-2">
      <lib-sura-skeleton
        align="center"
        figure="rectangle"
        [loading]="true"
        width="100%"
        height="10rem"
      >
      </lib-sura-skeleton>
      <div class="col-8 offset-2">
        <div class="pt-4 mx-auto">
          <lib-sura-skeleton
            align="center"
            figure="button"
            [loading]="true"
            width="60%"
            height="3rem"
          >
          </lib-sura-skeleton>
        </div>

        <div class="py-5 mx-auto">
          <lib-sura-skeleton
            align="center"
            figure="rectangle"
            [loading]="true"
            width="50%"
            height="2.5rem"
          >
          </lib-sura-skeleton>
        </div>
        <div class="pb-5 mx-auto">
          <lib-sura-skeleton
            align="center"
            figure="rectangle"
            [loading]="true"
            width="50%"
            height="2.5rem"
          >
          </lib-sura-skeleton>
        </div>
      </div>
    </div>
    <div class="pb-5 mx-auto">
      <lib-sura-skeleton
        figure="list"
        [loading]="true"
        width="50%"
        height="2.5rem"
      >
      </lib-sura-skeleton>
    </div>
  </div>

  <ng-template #sectionsContainer></ng-template>
</div>
<app-modal-error
  [error]="pagoFacade.error$ | async"
  (handleSubmitModalError)="clearErrorModal()"
></app-modal-error>
